import req from './../../../fetch';
import { paramsToString, undocumentedResponse } from './../../../utils';
import { AllAPIResponses, CarbonError } from './../../../index';

type Params = {
  email: string;
  refererOption?: string;
};
const get = async (
  params: Params,
  headers?: Headers
): Promise<AllAPIResponses<{}>> => {
  try {
    const resp = await req.get(
      `/api/resetpassword${paramsToString(params)}`,
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return { data: {}, response: clone };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return { data: (await resp.json()) as CarbonError, response: clone };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default get;
